import { useState, useEffect } from 'react';

//Custom Hook para calcular el largo de un contenedor de referencia.
const useHeigthCalculator = (containerRef) => {

    const [elementHeight, setElementHeight] = useState({ height: 0 }); //Estado para actualizar la altura del elemento.

    useEffect(() => { //Se ejecuta cada vez que el cambie la referencia.
        const handleResize = () => { //Función para calcular la nueva altura

            if (containerRef.current) {
                //se utiliza getBoundingClientRect para obtener lo posición y tamaño
                //del contenedor containerRef.
                const rect = containerRef.current.getBoundingClientRect();
                const heightContainer = rect.height;
                setElementHeight({ height: heightContainer });
            }
        };

        handleResize(); // Para que se ajuste inicialmente.

        //Se agrega un listener de evento de cambio de tamaño al window.
        //Cuando se detecta un cambio en el tamaño de la ventana se llama a la función handleResize.
        window.addEventListener("resize", handleResize);
        
        return () => { //Cuándo el componente se desmonta se elimina el listener del evento.  
            window.removeEventListener("resize", handleResize);
        };

    }, [containerRef]);

    return elementHeight; //Retorna el nuevo valor de height.

};

export default useHeigthCalculator;
